<template lang="html">
    <li>
        {{ category.name }}
        <button type="button" class="button red" @click.prevent="removeCategory">
            <img class="minus" src="@/assets/minus.svg" />
        </button>
    </li>
</template>

<script>
export default {
    name: "category-item",
    props: {
        category: {
            type: Object,
            required: true,
        },
    },
    methods: {
        removeCategory() {
            this.$confirm(
                "Are you sure you want to remove this category? This will also remove any offers in that category",
                () => {
                    window.axios.delete("/category/" + this.category.id);
                    this.$store.dispatch("removeCategory", this.category);
                },
            );
        },
    },
};
</script>

<style lang="scss" scoped>
li {
    background: white;
    border-radius: $radius;
    padding: 18px 20px;
    margin-bottom: 10px;
    color: $green_0;
    position: relative;
    height: 52px;
    button {
        position: absolute;
        top: 0px;
        width: 64px;
        height: 100% !important;
        right: 0px;
        border-radius: 0px;
        border-top-right-radius: $radius;
        border-bottom-right-radius: $radius;
        width: 64px;
        padding: 0px;
        .minus {
            margin-left: 7px;
        }
        &:before {
            content: "";
            width: 12px;
            background: blue;
            height: 100%;
            position: absolute;
            top: 0px;
            left: 0px;
            background: white;
            border-top-right-radius: $radius;
            border-bottom-right-radius: $radius;
        }
        &:focus {
            outline: 0;
        }
    }
}
</style>
